import gql from 'graphql-tag';
import locationFragment from './location';
import companyFragment from './company';

const name = 'entityInterface';
const fragment = gql`
  fragment ${name} on EntityInterface {
    id
    ... on Company {
      ...${companyFragment.name}
    }
    ... on Location {
      ...${locationFragment.name}
      logo {
        ...logo
      }
    }
  }

  ${locationFragment.fragment}
  ${companyFragment.fragment}
  fragment logo on Image {
    baseUrl
    id
    url
  }
`;

export default {
  name,
  fragment,
};
